
import { Toast } from "vant";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { H5AlipayBox, H5WechatBox } from "@/req/pay";
@Component
export default class Logout extends Vue {
  @Prop({ default: null }) public money;
  @Prop({ default: null }) public uid;
  public flag = true;
  public xuanz = false;
  public payMentId = 1;
  public propsName = "";

  public mounted() {
    this.propsName = `账户充值${this.money}元`;
  }
  @Watch("money")
  public moneyChange(val) {
    this.money = val;
    this.propsName = `账户充值${this.money}元`;
  }
  @Watch("uid")
  public uidChange(val) {
    this.uid = val;
  }
  public onClose() {
    this.$emit("closePayPopup", false);
  }
  public payMent(val) {
    this.payMentId = val;
    this.flag = true;
  }
  // 立即付款
  public async onPromptlyPay() {
    const obj = {
      token: this.$fn.cookies.getToken("token"),
      uid: this.uid,
      pay_amount: this.money,
      props_name: this.propsName,
    };
    let res;
    if (this.payMentId == 1) {
      res = await H5AlipayBox(obj);
    } else {
      res = await H5WechatBox(obj);
    }
    if (res.code == 200) {
      Toast(res.msg);
      window.open(res.data.url);
      this.onClose();
    } else {
      Toast(res.msg);
    }
  }
  // 支付宝微信支付
  public async getPay(val, order) {
    const sign = `order_id=${order}&pay_type=${
      val == 1 ? "1" : "2"
    }&token=${this.$fn.cookies.getToken("token")}`;
    const windowUrl = `${this.$HTTP_API.pay.hpay}?${sign}`;
    window.open(windowUrl);
  }
}
